import { render, staticRenderFns } from "./Sinistralidade.vue?vue&type=template&id=b8e18472&scoped=true"
import script from "./Sinistralidade.vue?vue&type=script&lang=js"
export * from "./Sinistralidade.vue?vue&type=script&lang=js"
import style0 from "./Sinistralidade.vue?vue&type=style&index=0&id=b8e18472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e18472",
  null
  
)

export default component.exports